import { Box, FormControl, MenuItem, OutlinedInput, Select, Typography } from "@mui/material"
import { useLocation, useNavigate } from "react-router-dom"
import { Back } from "../../../components/public/Button"
import { useCallback, useState } from "react"
import { toast } from "react-toastify"
import { useDispatch } from "react-redux"
import { useDropzone } from "react-dropzone"
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";

export const NewTemplate = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [planName, setPlanName] = useState("");
    const [categoryData, setCategoryData] = useState([]);
    const [templateType, setTemplateType] = useState("free");
    const RoleID = localStorage.getItem("role");
    const [open, setOpen] = useState(false);
    const [customerName, setCustomerName] = useState("");
    const [planDescription, setPlanDescription] = useState("");
    const [uploadedFile, setUploadedFile] = useState("");
    const [uploadedFileName, setUploadedFileName] = useState(null);
    const [planId, setPlanId] = useState("");
    const [loading, setLoading] = useState(false);
    const [category, setCategory] = useState("");
    const [tags, setTags] = useState("");

    const [planIdData, setPlanIdData] = useState(localStorage.getItem("planId") || "");
    const onDrop = useCallback((acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            setUploadedFileName(acceptedFiles[0].name);
            setUploadedFile(acceptedFiles[0]);
        } else {
            toast.error(
                <>
                    <div
                        style={{
                            fontFamily: "Inter, sans-serif",
                            fontSize: "14px",
                            fontWeight: "600",
                            lineHeight: "24px",
                            textAlign: "left",
                            marginBottom: "8px",
                        }}>
                        Plan Upload Unsuccessfull
                    </div>
                    <div
                        style={{
                            fontFamily: "Inter, sans-serif",
                            fontSize: "14px",
                            fontWeight: "500",
                            lineHeight: "22px",
                            textAlign: "left",
                        }}>
                        Something went wrong. Please check your file and try uploading again
                    </div>
                </>
            );
        }
    }, []);
    const [selectedValue, setSelectedValue] = useState("no"); // State to track selected radio button
    const [error, setError] = useState(false); // State to track validation error
    const location = useLocation();
    const [currency, setCurrency] = useState("USD");
    const [templateCost, setTemplateCost] = useState("");
    const [planData, setPlanData] = useState([]);
    const { getRootProps, getInputProps } = useDropzone({ onDrop });

    return (
        <Box sx={{}}>
            <div
                style={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "12px",
                    fontWeight: 500,
                    lineHeight: "14.52px",
                    textAlign: "left"
                }}>
                <span
                    style={{ cursor: "pointer" }}
                    onClick={() => { navigate("/admin/manage-templates") }}
                >Manage Template</span> &gt;{" "}
                Create Template
            </div>
            <Back prop={{ txt: 'Create Template' }} />
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "20px",
                    marginLeft: "2px",
                }}>
                <Typography
                    variant='body2'
                    sx={{
                        fontFamily: "Inter, sans-serif",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "20px",
                        textAlign: "left",
                    }}>
                    Template Name{" "}
                    <span
                        style={{
                            color: "#FF2800",
                            //backgroundColor: "#FF2800",
                            padding: "0 2px",
                            borderRadius: "50%",
                        }}>
                        *
                    </span>
                </Typography>
                <div style={{ marginLeft: "60px", flexGrow: 1 }}>
                    <FormControl sx={{ height: "32px", width: "100%" }}>
                        <OutlinedInput
                            placeholder='Enter Template Name'
                            value={planName}
                            onChange={(e) => setPlanName(e.target.value)}
                            sx={{
                                height: "100%",
                                backgroundColor: "white",
                                "& .MuiOutlinedInput-input": {
                                    // Styles for the input field
                                },
                                "& .MuiInputBase-input::placeholder": {
                                    fontFamily: "Inter, sans-serif",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    lineHeight: "20px",
                                    textAlign: "left",
                                },
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                        borderColor: "gray", // Default border color
                                    },
                                    "&:hover fieldset": {
                                        borderColor: "gray", // Border color on hover
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "gray", // Border color on focus
                                    },
                                },
                            }}
                        />
                    </FormControl>
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "10px",
                    marginLeft: "2px",
                }}>
                <Typography
                    variant='body2'
                    sx={{
                        fontFamily: "Inter, sans-serif",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "20px",
                        textAlign: "left",
                    }}>
                    Customer Name{" "}
                    <span
                        style={{
                            color: "#FF2800",
                            //backgroundColor: "#FF2800",
                            padding: "0 2px",
                            borderRadius: "50%",
                        }}>
                        *
                    </span>
                </Typography>
                <div style={{ marginLeft: 57, flexGrow: 1 }}>
                    <FormControl sx={{ height: "32px", width: "100%" }}>
                        <OutlinedInput
                            placeholder='Enter Customer Name'
                            value={customerName}
                            onChange={(e) => setCustomerName(e.target.value)}
                            sx={{
                                height: "100%",
                                backgroundColor: "white",
                                "& .MuiOutlinedInput-input": {
                                    // Styles for the input field
                                },
                                "& .MuiInputBase-input::placeholder": {
                                    fontFamily: "Inter, sans-serif",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    lineHeight: "20px",
                                    textAlign: "left",
                                },
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                        borderColor: "gray", // Default border color
                                    },
                                    "&:hover fieldset": {
                                        borderColor: "gray", // Border color on hover
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "gray", // Border color on focus
                                    },
                                },
                            }}
                        />
                    </FormControl>
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "10px",
                    marginLeft: "2px",
                }}>
                <Typography
                    variant='body2'
                    sx={{
                        fontFamily: "Inter, sans-serif",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "20px",
                        textAlign: "left",
                        marginBottom: "100px",
                    }}>
                    Template Description{" "}
                </Typography>
                <div style={{ marginLeft: "37px", flexGrow: 1 }}>
                    <FormControl sx={{ height: "100px", width: "100%" }}>
                        <OutlinedInput
                            placeholder='Enter Template Description'
                            value={planDescription}
                            onChange={(e) => setPlanDescription(e.target.value)}
                            multiline
                            rows={4} // Specify the number of rows for multiline
                            sx={{
                                height: "100%",
                                backgroundColor: "white",
                                "& .MuiOutlinedInput-input": {
                                    // Styles for the input field
                                },
                                "& .MuiInputBase-input::placeholder": {
                                    fontFamily: "Inter, sans-serif",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    lineHeight: "20px",
                                    textAlign: "left",
                                },
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                        borderColor: "gray", // Default border color
                                    },
                                    "&:hover fieldset": {
                                        borderColor: "gray", // Border color on hover
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "gray", // Border color on focus
                                    },
                                },
                            }}
                        />
                    </FormControl>
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "5px",
                    marginLeft: 5,
                }}>
                <Typography
                    variant='body2'
                    sx={{
                        fontFamily: "Inter, sans-serif",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "15px",
                        textAlign: "left",
                        marginBottom: "55px",
                    }}>
                    Upload file{" "}
                    <span
                        style={{
                            color: "#FF2800",
                            //backgroundColor: "#FF2800",
                            padding: "0 2px",
                            borderRadius: "50%",
                        }}>
                        *
                    </span>
                </Typography>
                <div style={{ marginLeft: 87, flexGrow: 1 }}>
                    <FormControl sx={{ height: "100px", width: "100%" }}>
                        <div
                            {...getRootProps()}
                            style={{
                                border: "1px solid lightgray",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "white",
                                cursor: "pointer",
                                borderRadius: "3px",
                            }}>
                            <input {...getInputProps()} />
                            <Box sx={{ textAlign: "center" }}>
                                <FileUploadOutlinedIcon
                                    style={{ fontSize: "30px", color: "gray" }}
                                />
                                <Typography
                                    variant='body2'
                                    sx={{
                                        fontFamily: "Inter, sans-serif",
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        lineHeight: "20px",
                                        color: "gray",
                                        marginTop: "5px",
                                    }}>
                                    Select a file or drag & drop the file
                                </Typography>
                                <Typography
                                    variant='body2'
                                    sx={{
                                        fontFamily: "Inter, sans-serif",
                                        fontSize: "14px", // Updated to your preferred font size
                                        fontWeight: 500,
                                        lineHeight: "20px",
                                        textAlign: "center", // Center-align text
                                        color: "#0057D5", // Updated text color
                                        marginTop: "8px",
                                    }}>
                                    {uploadedFileName
                                        ? `${uploadedFileName} file uploaded successfully`
                                        : ""}
                                </Typography>
                            </Box>
                        </div>
                    </FormControl>
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "5px",
                    marginLeft: "2px",
                }}>
                <Typography
                    variant='body2'
                    sx={{
                        fontFamily: "Inter, sans-serif",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "20px",
                        textAlign: "left",
                    }}>
                    Category{" "}
                    <span
                        style={{
                            color: "#FF2800",
                            //backgroundColor: "#FF2800",
                            padding: "0 2px",
                            borderRadius: "50%",
                        }}>
                        *
                    </span>
                </Typography>
                <div style={{ marginLeft: "68px", flexGrow: 1 }}>
                    <FormControl sx={{ height: "32px", width: "100%" }}>
                        <Select
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            displayEmpty
                            sx={{
                                height: "100%",
                                backgroundColor: "white",
                                fontFamily: "Inter, sans-serif",
                                fontSize: "12px",
                                fontWeight: 500,
                                lineHeight: "20px",
                                textAlign: "left",
                                marginLeft: 4,
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                        borderColor: "gray", // Default border color
                                    },
                                    "&:hover fieldset": {
                                        borderColor: "gray", // Border color on hover
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "gray", // Border color on focus
                                    },
                                },
                            }}
                        >
                            <MenuItem value="" disabled>
                                Enter Category
                            </MenuItem>
                            {categoryData.map((item) => (
                                <MenuItem key={item.value} value={item.value}>
                                    {item.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "5px",
                    marginLeft: "5px",
                }}>
                <Typography
                    variant='body2'
                    sx={{
                        fontFamily: "Inter, sans-serif",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "20px",
                        textAlign: "left",
                    }}>
                    Tags{" "}
                </Typography>
                <div style={{ marginLeft: "110px", flexGrow: 1 }}>
                    <FormControl sx={{ height: "32px", width: "100%" }}>
                        <OutlinedInput
                            placeholder='Enter Tags'
                            value={tags}
                            onChange={(e) => setTags(e.target.value)}
                            sx={{
                                height: "100%",
                                backgroundColor: "white",
                                marginLeft: 4,
                                "& .MuiOutlinedInput-input": {
                                    // Styles for the input field
                                },
                                "& .MuiInputBase-input::placeholder": {
                                    fontFamily: "Inter, sans-serif",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                    lineHeight: "20px",
                                    textAlign: "left"
                                },
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                        borderColor: "gray", // Default border color
                                    },
                                    "&:hover fieldset": {
                                        borderColor: "gray", // Border color on hover
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "gray", // Border color on focus
                                    },
                                },
                            }}
                        />
                    </FormControl>
                </div>
            </div>
        </Box>
    )
}